import { cn } from "@/lib/utils";
import React from "react";

interface MetaItem {
  id: string | number;
  meta_title: string;
  meta_subtitle: string;
  meta_priority: number;
  meta_title_text_color?: string;
  meta_subtitle_text_color?: string;
  meta_background_color?: string;
}

interface KeyNumbersCardProps {
  keyNumber: MetaItem;
  index: number;
  totalCount?: number;
}

const KeyNumbersCard: React.FC<KeyNumbersCardProps> = ({
  keyNumber,
  index,
  totalCount = 4,
}) => {
  const {
    meta_title,
    meta_subtitle,
    meta_title_text_color = "#FFFFFF",
    meta_subtitle_text_color = "#FFFFFF",
  } = keyNumber;

  const isTwoItems = totalCount === 2;
  const isFourItems = totalCount === 4;

  return (
    <div
      className={cn(
        "flex flex-col items-center gap-0 shrink-0",
        // For 4 items: add plus sign borders on mobile, remove on desktop
        isFourItems && {
          "border-r-[1px] border-primary-4": index === 0 || index === 2,
          "border-b-[1px] border-primary-4 pb-5": index < 2,
          "pt-5": index > 1,
        },
        // Remove borders on desktop for 4 items
        isFourItems && "sm:border-r-0 sm:border-b-0 sm:pt-0 sm:pb-0",
        // Responsive direction
        "sm:flex-row sm:py-0 sm:gap-spacing-10",
      )}
    >
      <div
        className={cn(
          "shrink-0 whitespace-nowrap text-heading-2-bold",
          "sm:text-[44px] sm:font-bold sm:leading-none",
          "md:text-[52px] lg:text-[60px] xl:text-[72px]",
          "type-h2",
        )}
        style={{ color: meta_title_text_color }}
      >
        {meta_title}
      </div>
      <div
        className={cn(
          "text-center sm:text-left",
          "xs:max-w-[144px] xs:mx-auto",
          "text-body-2-regular",
          "sm:text-new-body-3-regular",
          "md:text-new-body-2-regular",
          "lg:text-heading-7-regular lg:max-w-[144px]",
          "xl:text-new-body-24-regular",
          "type-body",
          // "line-clamp-1 sm:line-clamp-2"
        )}
        style={{ color: meta_subtitle_text_color }}
      >
        {meta_subtitle}
      </div>
    </div>
  );
};

export default KeyNumbersCard;
